var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DownloadModelsTable',{attrs:{"title":"Download Hit Generation Models","category-filter":"Hit Generation"}})
}
var staticRenderFns = []

export { render, staticRenderFns }